
/*
Rohini 10/29/2022 3225736869 add classname globally for the textfields and buttons
Prakash 10/31/2022 3225736869 added classname   buttons
Lalitha  11/9/2022 3225736869  Rename Button Cancel to Reset
Suresh Peddavoora 03/20/2023 3225736869 Removed Classnames for textfields
*/
import React, {useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {useSelector} from 'react-redux';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const taskTypes = [
  {key: 'Event Tactic', value: 'Event Tactic'},
  {key: 'Run Report', value: 'Run Report'},
];

const TaskForm = ({
  setOpen,
  formData,
  setFormData,
  rowData,
  isEditMode,
  oldRuleCode,
  setIsEditMode,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const {nightJobData} = useSelector(({addNightJob}) => addNightJob);

  const initialValues = {
    taskCode: isEditMode && rowData && rowData.taskCode ? rowData.taskCode : '',
    taskType: isEditMode && rowData && rowData.taskType ? rowData.taskType : '',
    parameters: isEditMode && rowData && rowData.parameters ? rowData.parameters : '',
  };

  const [currentRuleCode, setCurrentRuleCode] = useState(rowData?.taskCode || '');

  const schema = Yup.object().shape({
    taskCode:
      rowData?.taskCode === currentRuleCode && isEditMode ?
        '' :
        Yup.string()
          .notOneOf(
            formData.map((data) => data.taskCode),
            'Task code already exists',
          ).required('Task Code is required').matches(
            /^[a-zA-Z0-9]+$/,
            'White space and special character are not allowed',
          )
          .required('Task code is required'),
    taskType: Yup.string()
      .notOneOf(['none'], 'Task type is required')
      .required('Task type is required')
      .nullable(),
  });

  const handleSubmit = (values) => {
    values.taskCode = values.taskCode.toUpperCase();
    const data = {...values};
    const copyData = [...formData];

    if (!isEditMode) {
      copyData.push({...data, tableData: {checked: true}});
      setFormData(copyData);
      setOpen(false);
    } else {
      const updatedData = copyData.map((each) => {
        if (each.taskCode === oldRuleCode) {
          return {
            ...each,
            taskCode: data.taskCode,
            taskType: data.taskType,
            parameters: data.parameters,
          };
        } else {
          return {...each};
        }
      });
      setFormData(updatedData);
      setOpen(false);
      setIsEditMode(false);
    }
  };
  return (
    <div className={classes.addRule}>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              setFieldValue,
              handleReset,
              handleBlur,
              touched,
              errors,
            } = props;
            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid container className="global-field-textfields new-standard-textfields" spacing={2}>
                        <Grid item xs={6} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Task Code`}
                            label="Task Code"
                            disabled={nightJobData?.tasks?.length > 0 && isEditMode}
                            // className={` ${classes.labelName} ${classes.inputLabel}`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="taskCode"
                            required
                            value={values?.taskCode?.toUpperCase()}
                            onChange={(e) => {
                              setCurrentRuleCode(e.target.value);
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.taskCode}
                            error={Boolean(touched.taskCode && errors.taskCode)}
                          />
                          <FormHelperText>
                            {touched.taskCode && errors.taskCode && errors.taskCode}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} className="form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="taskType"
                            id="taskType"
                            size="small"
                            value={values.taskType}
                            options={taskTypes.map((each) => each.key)}
                            required
                            onChange={(e, value) => {
                              setFieldValue('taskType', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  error={Boolean(touched.taskType && errors.taskType)}
                                  variant="outlined"
                                  margin="dense"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  required
                                  label="Task Type"
                                  placeholder="Select Task Type"
                                  // className={` ${classes.labelName} ${classes.selectLabel}`}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText>
                            {touched.taskType && errors.taskType && errors.taskType}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={12} className="form-group">
                          <TextField
                            margin="dense"
                            minRows={2}
                            variant="outlined"
                            placeholder={`Enter Task Parameters`}
                            multiline
                            label="Task Parameters"
                            // className={` ${classes.labelName} ${classes.inputLabel}`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="parameters"
                            value={values.parameters}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.parameters}
                            error={Boolean(touched.parameters && errors.parameters)}
                          />
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                  <div className="button-spacing-mb new-standard-textfields">
                    <Button
                      variant="outlined"
                      onClick={handleReset}
                      className={`mr-1 reset-btn ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                    >
                      {isEditMode ? 'Update Task' : 'Add Task'}
                    </Button>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default TaskForm;
